/**
 * Modal init
 */

class ModalInit {

    constructor() {
        function closeModal(event) {
            // close modal, if open
            let modalHide = document.getElementById('modal-hide');
            if (modalHide) {
                modalHide.click();
            }
        }

        htmx.on('htmx:beforeSwap', (event) => {
            closeModal(event);
        });

        htmx.on('htmx:historyRestore', (event) => {
            closeModal(event);
        });

        htmx.on('htmx:historyCacheMiss', (event) => {
            closeModal(event);
        });
    }
}

export default ModalInit;